import AxiosAdminAPI from "../../../../util/AxiosAdminAPI";
import {V1DocumentTypeIDOCToArray} from "../../../../util/Payload";
import EnterpriseComponent from "../../EnterpriseComponent";
import {v4 as uuidv4} from "uuid";

class DocumentTypeEnterpriseComponent extends EnterpriseComponent {
    performQuery = (page, pageSize, foreignKey) => {
        page = page || 1;
        pageSize = pageSize || this.getDefaultCacheSize();

        this.notifyLoadStartListeners();

        let idocResponse = this.getIDOCResponse() ?? "v1.DocumentType-001";

        let QBE = {
            "PlatformMessage": {
                "-idoc": idocResponse,
                "-id": uuidv4(),
                "DocumentType": {
                    '_attributes': {
                        'limit': pageSize,
                        'sort': this.getFormattedSortSpecification(),
                        'offset': (page - 1) * pageSize
                    },
                    "QueryGroups": {
                        "QueryGroup": [
                            {
                                "Name": "primary",
                                "Operator": "AND",
                                "Type": "QueryGroup",
                                "Membership": {
                                    "Member": []
                                }
                            }
                        ]
                    }
                }
            }
        }
        let queryPayload = this.prepareQueryPayload();

        if (queryPayload.size > 0) {
            for (const [key, value] of queryPayload) {
                if (key.includes("_query")) continue;

                let operator = "EQUAL";
                if (queryPayload.get(key + "_query") !== undefined) {
                    operator = queryPayload.get(key + "_query")
                }
                QBE.PlatformMessage.DocumentType.QueryGroups.QueryGroup[0].Membership.Member.push({
                    "Type": "Attribute",
                    "Name": key,
                    "Value": value,
                    "Operator": operator
                })
            }
        }

        AxiosAdminAPI({
            method: "GET",
            url: "t6/v1/document_types",
            json: true,
            params: {
                "QBE": btoa(JSON.stringify(QBE))
            },
            headers: {
                "idoc-response": idocResponse,
            },
        }).then(response => {
            this.fetchEnterpriseComponentSuccess(V1DocumentTypeIDOCToArray(response.data), page, pageSize);
        }).catch(error => {
            this.fetchEnterpriseComponentFailed(error);
        });
    };

    enterpriseComponentPutIDOC = () => {
        let payload = {};

        payload.PlatformMessage = {};
        payload.PlatformMessage["-idoc"] = "v1.DocumentType-002";
        payload.PlatformMessage.DocumentType = this.preparePUTPayload();

        return payload;
    };

    performUpdate = () => {
        let payload = this.enterpriseComponentPutIDOC();

        let options = {
            method: "PUT",
            url: "t6/v1/document_types",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.DocumentType-002",
                "idoc-response": "v1.DocumentType-002",
            },
        };
        this.notifyUpdateStartListeners();
        AxiosAdminAPI(options)
            .then(response => {
                this.updateEnterpriseComponentSuccess(V1DocumentTypeIDOCToArray(response.data));
            })
            .catch(error => {
                this.updateEnterpriseComponentFailed(error);
            });
    };

    enterpriseComponentPostIDOC = () => {
        let payload = {};

        let documentType = {};

        documentType["USID"] = this.getAttributeValue("USID");
        documentType["DocumentTypeName"] = this.getAttributeValue("DocumentTypeName");
        documentType["DocumentTypeAcronym"] = this.getAttributeValue("DocumentTypeAcronym");
        documentType["DocumentTypeGroup"] = this.getAttributeValue("DocumentTypeGroup");
        documentType["PrivateNumberPool"] = this.getAttributeValue("PrivateNumberPool");
        documentType["StartingNumber"] = this.getAttributeValue("StartingNumber");
        documentType["DefaultSchema"] = this.getAttributeValue("DefaultSchema");
        documentType["Active"] = this.getAttributeValue("Active");
        documentType["DefaultRevisionStage"] = this.getAttributeValue("DefaultRevisionStage");
        documentType["NumberOfDocumentDigits"] = this.getAttributeValue("NumberOfDocumentDigits");

        payload.PlatformMessage = {};
        payload.PlatformMessage["-idoc"] = "v1.DocumentType-002";
        payload.PlatformMessage.DocumentType = documentType;

        return payload;
    };

    performInsert = () => {
        let payload = this.enterpriseComponentPostIDOC();

        let options = {
            method: "POST",
            url: "t6/v1/document_types",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.DocumentType-002",
                "idoc-response": "v1.DocumentType-002",
            },
        };
        this.notifyInsertStartListeners();
        AxiosAdminAPI(options)
            .then(response => {
                this.insertEnterpriseComponentSuccess(V1DocumentTypeIDOCToArray(response.data));
            })
            .catch(error => {
                this.insertEnterpriseComponentFailed(error);
            });
    };
}

export default DocumentTypeEnterpriseComponent;
